import { deleteCookie, getCookie, setCookie } from 'cookies-next'
import { OptionsType } from 'cookies-next/lib/types'
import { CookieValueTypes } from 'cookies-next/src/types'

export enum CookieKeys {
  RegistrantToken = 'registrantToken',
}

export class CookieService {
  public static setItem(key: string, value: any, options?: OptionsType): void {
    setCookie(key, value, options)
  }

  public static getItem(key: string): CookieValueTypes
  public static getItem(key: string, isServer: true): Promise<CookieValueTypes>
  public static getItem(key: string, isServer = false): CookieValueTypes | Promise<CookieValueTypes> {
    if (!isServer) {
      return getCookie(key)
    }

    return (async () => {
      const { cookies } = await import('next/headers')

      return getCookie(key, { cookies })
    })()
  }

  public static removeItem(key: string): void {
    deleteCookie(key)
  }
}
